import Confirm from '@/components/global-modal-components/modal-templates/confirm.modal.vue';
import Error from '@/components/global-modal-components/modal-templates/error.modal.vue';
import HelpText from '@/components/global-modal-components/modal-templates/help-text.modal.vue';
import Loading from '@/components/global-modal-components/modal-templates/loading.modal.vue';

import { dialogMaxWidth } from '@/constants';

export let components = {
  Confirm,
  HelpText,
  Loading,
  Error,
};

export let configs = {
  Confirm: {
    persistent: true,
  },
  Loading: {
    maxWidth: '500px',
    persistent: true,
  },
  Error: {
    maxWidth: dialogMaxWidth,
    persistent: true,
  },
};
